import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { FilterSelectionListComponent } from './filter-selection-list.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [FilterSelectionListComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatTableModule,
    MatCheckboxModule,
    MatListModule,
    MatIconModule,
  ],
  exports: [FilterSelectionListComponent],
  providers: [],
})
export class FilterSelectionListModule {}
